import axios from 'axios';
const { PUBLIC_URL } = process.env;

const getMessages = async languageTag => {
  const response = await axios.get(
    PUBLIC_URL + `/i18n/${languageTag}.json?timestamp=${new Date().getTime()}`
  );
  return response;
};

export { getMessages };



// WEBPACK FOOTER //
// ./src/apis/MessagesApi.js